async function request(path, options = {}) {
  const response = await fetch(path, {
    ...options,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
  });
  const isJson = response.headers.get('content-type')?.includes('application/json');
  const body = isJson ? await response.json() : null;
  if (!response.ok) {
    const error = new Error(body?.detail || `Request failed: ${response.status}`);
    error.status = response.status;
    error.body = body;
    throw error;
  }
  return body;
}

export const authApi = {
  // 0.48.25 - extra: the bot check's token and hidden field.
  signup: (email, password, extra = {}) => request('/api/auth/signup', {
    method: 'POST', body: JSON.stringify({ email, password, ...extra }),
  }),
  signupCheck: () => request('/api/auth/signup-check'),
  login: (email, password) => request('/api/auth/login', {
    method: 'POST', body: JSON.stringify({ email, password }),
  }),
  logout: () => request('/api/auth/logout', { method: 'POST' }),
  me: () => request('/api/auth/me'),
  dismissLanguageNotice: () => request('/api/auth/dismiss-language-notice', { method: 'POST' }),
  dismiss2faDisabledNotice: () => request('/api/auth/dismiss-2fa-disabled-notice', { method: 'POST' }),
  submit2faChallenge: (challenge_token, code, trust_device) =>
    request('/api/auth/2fa/challenge', {
      method: 'POST',
      body: JSON.stringify({ challenge_token, code, trust_device }),
    }),
  resend2faCode: (challenge_token) =>
    request('/api/auth/2fa/resend', {
      method: 'POST',
      body: JSON.stringify({ challenge_token }),
    }),
};

export const authActionsApi = {
  dismissLanguageNotice: () => request('/api/auth/dismiss-language-notice', { method: 'POST' }),
};
